<div class="technical-data-container">
  <div class="content">
    <div class="headline"> {{ 'pdp.info.technicalData.headline' | translate }} </div>
    <div class="table">
      <div class="technical-data" *ngFor="let data of showCompleteList ? technicalDetails : technicalDetails.slice(0,8)">
        <div class="key"> {{ data.key }} </div>
        <div class="value"> {{ data.value }} </div>
      </div>
    </div>
    <kion-button
      mode="discreet"
      [title]="'pdp.info.button.showMore' | translate"
      [hidden]="showCompleteList || technicalDetails.length <= 8"
      (clicked)="showAll()"
    ></kion-button>
  </div>
</div>
